import { Fragment, FunctionComponent, h } from 'preact'
import { RoutableProps } from 'preact-router'

export const Member: FunctionComponent<RoutableProps> = () => {
  return (
    <Fragment>
      <section className="section">
        <div className="section-title">2022</div>
        <details className="details" open>
          <summary className="summary">役員</summary>
          <ul className="list">
            <li className="list-item--disc">代表: 小倉洸太 (島根大学, M1)</li>
            <li className="list-item--disc">副代表: Md Atikur Rahman (鳥取大学, D1)</li>
            <li className="list-item--disc">庶務: 橋本翼 (鳥取大学, M1)</li>
            <li className="list-item--disc">WEB管理/広報: 山田拓也 (鳥取大学, M1)</li>
          </ul>
        </details>
      </section>
      <section className="section">
        <div className="section-title">2021</div>
        <details className="details" open>
          <summary className="summary">役員</summary>
          <ul className="list">
            <li className="list-item--disc">代表: 河越祐太 (鳥取大学, M2)</li>
            <li className="list-item--disc">副代表: 小倉洸太 (島根大学, M1)</li>
            <li className="list-item--disc">庶務: 角脇永吉 (鳥取大学, M2)</li>
            <li className="list-item--disc">会計: Md Atikur Rahman (鳥取大学, D1)</li>
          </ul>
        </details>
      </section>
      <section className="section">
        <div className="section-title">2020</div>
        <details className="details" open>
          <summary className="summary">役員</summary>
          <ul className="list">
            <li className="list-item--disc">代表: 伊藤太清 (島根大学, M2)</li>
            <li className="list-item--disc">副代表: 清水健 (鳥取大学, M2)</li>
          </ul>
        </details>
      </section>
      <section className="section">
        <div className="section-title">2019</div>
        <details className="details" open>
          <summary className="summary">役員</summary>
          <ul className="list">
            <li className="list-item--disc">代表: 磯本佳助 (鳥取大学, D1)</li>
            <li className="list-item--disc">副代表: 伊藤太清 (島根大学, M1)</li>
            <li className="list-item--disc">庶務: 岡野圭祐 (鳥取大学, D2)</li>
            <li className="list-item--disc">会計: 金城希望 (鳥取大学, M2)</li>
            <li className="list-item--disc">WEB管理/広報: 山下和也 (島根大学, M2)</li>
            <li className="list-item--disc">WEB管理/広報: 水将人 (鳥取大学, M2)</li>
          </ul>
        </details>
        <details className="details">
          <summary className="summary">会員</summary>
          <ul className="list">
            <li className="list-item--disc"></li>
          </ul>
        </details>
      </section>
      <section className="section">
        <div className="section-title">2018</div>
        <details className="details" open>
          <summary className="summary">役員</summary>
          <ul className="list">
            <li className="list-item--disc">代表: 磯本佳助 (鳥取大学, M2)</li>
            <li className="list-item--disc">副代表: 伊藤太清 (島根大学, B4)</li>
            <li className="list-item--disc">庶務: 岡野圭祐 (鳥取大学, D1)</li>
            <li className="list-item--disc">会計: 金城希望 (鳥取大学, M1)</li>
            <li className="list-item--disc">WEB管理/広報: 山下和也 (島根大学, M1)</li>
            <li className="list-item--disc">WEB管理/広報: 水将人 (鳥取大学, M1)</li>
          </ul>
        </details>
        <details className="details">
          <summary className="summary">会員</summary>
          <ul className="list">
            <li className="list-item--disc"></li>
          </ul>
        </details>
      </section>
    </Fragment>
  )
}
